// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3OhtB","rootCenter":"LoadMoreObserver_rootCenter__1jbzK","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__33DL4"};